module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_9_1.2f2f0498.png";